import { useExperiment } from '@printdeal/feature-management/react';
import React, { lazy } from 'react';
import { SelectorContent } from '@printdeal/product-selector';
import { isCustomerProgramReseller, useSegmentation } from '@printdeal/segmentation/react';
import { DeliveryToolSettings, type SelectedDeliveryTool } from '../../../../../types/file-delivery/FileDelivery';
import { IProductPage } from '../../../../../types/product/productDetailPage';

const ProductSummary = lazy(() => import(/* webpackChunkName: "product-summary" */ '../Summary/ProductSummary'));

interface Props {
  hasFileDeliveryChoice: boolean;
  selectedDeliveryTool: SelectedDeliveryTool | undefined;
  alternativeUploadService: string | undefined;
  deliveryTool: DeliveryToolSettings;
  isDirectUploadConfigured: boolean;
  isChoiceSkipped: boolean;

  productName: string;
  selector: SelectorContent;
  pageContent: IProductPage;
  selectedServices: string[];
  customerGroupId: string | undefined;
  isExp1853Variant: boolean;
}

const ProductSummaryExp1862 = ({
  hasFileDeliveryChoice,
  selectedDeliveryTool,
  alternativeUploadService,
  deliveryTool,
  isDirectUploadConfigured,
  isChoiceSkipped,

  productName,
  selector,
  pageContent,
  selectedServices,
  customerGroupId,
  isExp1853Variant,
}: Props) => {
  const {
    experiment: exp1862,
  } = useExperiment('servicesprouts_exp1862_rerun_explicit_choice_filecheck');
  const segmentation = useSegmentation();
  const isReseller = isCustomerProgramReseller(
    segmentation.data?.isReseller,
    segmentation.data?.isPartOfCustomerProgram,
  );
  const isExp1862Variant = Boolean(exp1862?.variation === 'variant') && !isReseller;

  if (hasFileDeliveryChoice && !selectedDeliveryTool && !isChoiceSkipped && !isDirectUploadConfigured) {
    // if there is delivery choice, no delivery tool selected, choice not skipped
    // and no direct upload configured then don't show product summary.
    return null;
  }

  if (isExp1862Variant
    && deliveryTool?.servicekeys
    && (!selectedServices || !alternativeUploadService)
    && !isChoiceSkipped
  ) {
    // if exp1862 variant, then if we have available services and no services selected then don't show product summary
    return null;
  }
  return (
    <ProductSummary
      productName={productName}
      selector={selector}
      pageContent={pageContent}
      selectedDeliveryTool={selectedDeliveryTool}
      selectedServices={selectedServices}
      customerGroupId={customerGroupId}
      isExp1853Variant={isExp1853Variant}
    />
  );
};

export default ProductSummaryExp1862;
